import { IDataGenericText, IDataGrouped } from "@app/interfaces/idata-grouped";

export let ADDRESS1DB = [
    { id: 1, address1: 'Región de Arica y Parinacota', abbrName: 'Arica y Parinacota' },
    { id: 2, address1: 'Región de Tarapacá', abbrName: 'Tarapacá' },
    { id: 3, address1: 'Región de Antofagasta', abbrName: 'Antofagasta' },
    { id: 4, address1: 'Región de Atacama', abbrName: 'Atacama' },
    { id: 5, address1: 'Región de Coquimbo', abbrName: 'Coquimbo' },
    { id: 6, address1: 'Región de Valparaiso', abbrName: 'Valparaiso' },
    { id: 7, address1: 'Región Metropolitana de Santiago', abbrName: 'Metropolitana' },
    { id: 8, address1: 'Región del Libertador General Bernardo O\'Higgins', abbrName: 'Libertador Bernardo O\'Higgins' },
    { id: 9, address1: 'Región del Maule', abbrName: 'Maule' },
    { id: 10, address1: 'Región de Ñuble', abbrName: 'Ñuble' },
    { id: 11, address1: 'Región del Biobío', abbrName: 'Biobío' },
    { id: 12, address1: 'Región de La Araucanía', abbrName: 'La Araucanía' },
    { id: 13, address1: 'Región de Los Ríos', abbrName: 'Los Ríos' },
    { id: 14, address1: 'Región de Los Lagos', abbrName: 'Los Lagos' },
    { id: 15, address1: 'Región de Aysén del General Carlos Ibáñez del Campo', abbrName: 'Aysén' },
    { id: 16, address1: 'Región de Magallanes y de la Antártica Chilena', abbrName: 'Magallanes y Antártica Chilena' }];

export let ADDRESS3_LIST: Array<IDataGenericText>
    = [
        { parent: 'Región de Arica y Parinacota', text: 'Arica', id: 1 },
        { parent: 'Región de Arica y Parinacota', text: 'Camarones', id: 2 },
        { parent: 'Región de Arica y Parinacota', text: 'General Lagos', id: 3 },
        { parent: 'Región de Arica y Parinacota', text: 'Putre', id: 4 },
        { parent: 'Región de Tarapacá', text: 'Alto Hospicio', id: 5 },
        { parent: 'Región de Tarapacá', text: 'Camiña', id: 7 },
        { parent: 'Región de Tarapacá', text: 'Colchane', id: 8 },
        { parent: 'Región de Tarapacá', text: 'Huara', id: 9 },
        { parent: 'Región de Tarapacá', text: 'Iquique', id: 6 },
        { parent: 'Región de Tarapacá', text: 'Pica', id: 10 },
        { parent: 'Región de Tarapacá', text: 'Pozo Almonte', id: 11 },
        { parent: 'Región de Antofagasta', text: 'Antofagasta', id: 17 },
        { parent: 'Región de Antofagasta', text: 'Calama', id: 14 },
        { parent: 'Región de Antofagasta', text: 'María Elena', id: 13 },
        { parent: 'Región de Antofagasta', text: 'Mejillones', id: 18 },
        { parent: 'Región de Antofagasta', text: 'Ollague', id: 15 },
        { parent: 'Región de Antofagasta', text: 'San Pedro de Atacama', id: 16 },
        { parent: 'Región de Antofagasta', text: 'Sierra Gorda', id: 19 },
        { parent: 'Región de Antofagasta', text: 'Taltal', id: 20 },
        { parent: 'Región de Antofagasta', text: 'Tocopilla', id: 12 },
        { parent: 'Región de Atacama', text: 'Alto del Carmen', id: 27 },
        { parent: 'Región de Atacama', text: 'Caldera', id: 24 },
        { parent: 'Región de Atacama', text: 'Chañaral', id: 21 },
        { parent: 'Región de Atacama', text: 'Copiapó', id: 23 },
        { parent: 'Región de Atacama', text: 'Diego de Almagro', id: 22 },
        { parent: 'Región de Atacama', text: 'Freirina', id: 28 },
        { parent: 'Región de Atacama', text: 'Huasco', id: 29 },
        { parent: 'Región de Atacama', text: 'Tierra Amarilla', id: 25 },
        { parent: 'Región de Atacama', text: 'Vallenar', id: 26 },
        { parent: 'Región de Coquimbo', text: 'Andacollo', id: 32 },
        { parent: 'Región de Coquimbo', text: 'Canela', id: 42 },
        { parent: 'Región de Coquimbo', text: 'Combarbalá', id: 37 },
        { parent: 'Región de Coquimbo', text: 'Coquimbo', id: 31 },
        { parent: 'Región de Coquimbo', text: 'Illapel', id: 41 },
        { parent: 'Región de Coquimbo', text: 'La Higuera', id: 33 },
        { parent: 'Región de Coquimbo', text: 'La Serena', id: 30 },
        { parent: 'Región de Coquimbo', text: 'Los Vilos', id: 43 },
        { parent: 'Región de Coquimbo', text: 'Monte Patria', id: 38 },
        { parent: 'Región de Coquimbo', text: 'Ovalle', id: 36 },
        { parent: 'Región de Coquimbo', text: 'Paihuano', id: 34 },
        { parent: 'Región de Coquimbo', text: 'Punitaqui', id: 39 },
        { parent: 'Región de Coquimbo', text: 'Río Hurtado', id: 40 },
        { parent: 'Región de Coquimbo', text: 'Salamanca', id: 44 },
        { parent: 'Región de Coquimbo', text: 'Vicuña', id: 35 },
        { parent: 'Región de Valparaiso', text: 'Algarrobo', id: 76 },
        { parent: 'Región de Valparaiso', text: 'Cabildo', id: 46 },
        { parent: 'Región de Valparaiso', text: 'Calle Larga', id: 52 },
        { parent: 'Región de Valparaiso', text: 'Cartagena', id: 73 },
        { parent: 'Región de Valparaiso', text: 'Casablanca', id: 70 },
        { parent: 'Región de Valparaiso', text: 'Catemu', id: 58 },
        { parent: 'Región de Valparaiso', text: 'Concón', id: 67 },
        { parent: 'Región de Valparaiso', text: 'El Quisco', id: 75 },
        { parent: 'Región de Valparaiso', text: 'El Tabo', id: 74 },
        { parent: 'Región de Valparaiso', text: 'Hijuelas', id: 64 },
        { parent: 'Región de Valparaiso', text: 'Isla de Pascua', id: 78 },
        { parent: 'Región de Valparaiso', text: 'Juan Fernández', id: 71 },
        { parent: 'Región de Valparaiso', text: 'La Calera', id: 62 },
        { parent: 'Región de Valparaiso', text: 'La Cruz', id: 61 },
        { parent: 'Región de Valparaiso', text: 'La Ligua', id: 45 },
        { parent: 'Región de Valparaiso', text: 'Limache', id: 80 },
        { parent: 'Región de Valparaiso', text: 'Llaillay', id: 55 },
        { parent: 'Región de Valparaiso', text: 'Los Andes', id: 50 },
        { parent: 'Región de Valparaiso', text: 'Nogales', id: 63 },
        { parent: 'Región de Valparaiso', text: 'Olmué', id: 81 }, 
        { parent: 'Región de Valparaiso', text: 'Panquehue', id: 59 },
        { parent: 'Región de Valparaiso', text: 'Papudo', id: 48 },
        { parent: 'Región de Valparaiso', text: 'Petorca', id: 49 },
        { parent: 'Región de Valparaiso', text: 'Puchuncaví', id: 69 },
        { parent: 'Región de Valparaiso', text: 'Putaendo', id: 56 },
        { parent: 'Región de Valparaiso', text: 'Quillota', id: 60 },
        { parent: 'Región de Valparaiso', text: 'Quilpué', id: 79 },
        { parent: 'Región de Valparaiso', text: 'Quintero', id: 68 },
        { parent: 'Región de Valparaiso', text: 'Rinconada', id: 53 },
        { parent: 'Región de Valparaiso', text: 'San Antonio', id: 72 },
        { parent: 'Región de Valparaiso', text: 'San Esteban', id: 51 },
        { parent: 'Región de Valparaiso', text: 'San Felipe', id: 54 },
        { parent: 'Región de Valparaiso', text: 'Santa María', id: 57 },
        { parent: 'Región de Valparaiso', text: 'Santo Domingo', id: 77 },
        { parent: 'Región de Valparaiso', text: 'Valparaíso', id: 65 },
        { parent: 'Región de Valparaiso', text: 'Villa Alemana', id: 82 },
        { parent: 'Región de Valparaiso', text: 'Viña del Mar', id: 66 },
        { parent: 'Región de Valparaiso', text: 'Zapallar', id: 47 },
        { parent: 'Región Metropolitana de Santiago', text: 'Alhué', id: 126 },
        { parent: 'Región Metropolitana de Santiago', text: 'Buin', id: 122 },
        { parent: 'Región Metropolitana de Santiago', text: 'Calera de Tango', id: 124 },
        { parent: 'Región Metropolitana de Santiago', text: 'Cerrillos', id: 117 },
        { parent: 'Región Metropolitana de Santiago', text: 'Cerro Navia', id: 116 },
        { parent: 'Región Metropolitana de Santiago', text: 'Colina', id: 83 },
        { parent: 'Región Metropolitana de Santiago', text: 'Conchalí', id: 115 },
        { parent: 'Región Metropolitana de Santiago', text: 'Curacaví', id: 127 },
        { parent: 'Región Metropolitana de Santiago', text: 'El Bosque', id: 114 },
        { parent: 'Región Metropolitana de Santiago', text: 'El Monte', id: 131 },
        { parent: 'Región Metropolitana de Santiago', text: 'Estación Central', id: 113 },
        { parent: 'Región Metropolitana de Santiago', text: 'Huechuraba', id: 112 },
        { parent: 'Región Metropolitana de Santiago', text: 'Independencia', id: 111 },
        { parent: 'Región Metropolitana de Santiago', text: 'Isla de Maipo', id: 130 },
        { parent: 'Región Metropolitana de Santiago', text: 'La Cisterna', id: 110 },
        { parent: 'Región Metropolitana de Santiago', text: 'La Florida', id: 109 },
        { parent: 'Región Metropolitana de Santiago', text: 'La Granja', id: 108 },
        { parent: 'Región Metropolitana de Santiago', text: 'La Pintana', id: 107 },
        { parent: 'Región Metropolitana de Santiago', text: 'La Reina', id: 106 },
        { parent: 'Región Metropolitana de Santiago', text: 'Lampa', id: 84 },
        { parent: 'Región Metropolitana de Santiago', text: 'Las Condes', id: 105 },
        { parent: 'Región Metropolitana de Santiago', text: 'Lo Barnechea', id: 104 },
        { parent: 'Región Metropolitana de Santiago', text: 'Lo Espejo', id: 103 },
        { parent: 'Región Metropolitana de Santiago', text: 'Lo Prado', id: 102 },
        { parent: 'Región Metropolitana de Santiago', text: 'Macul', id: 101 },
        { parent: 'Región Metropolitana de Santiago', text: 'Maipú', id: 100 },
        { parent: 'Región Metropolitana de Santiago', text: 'María Pinto', id: 128 },
        { parent: 'Región Metropolitana de Santiago', text: 'Melipilla', id: 125 },
        { parent: 'Región Metropolitana de Santiago', text: 'Ñuñoa', id: 99 },
        { parent: 'Región Metropolitana de Santiago', text: 'Padre Hurtado', id: 132 },
        { parent: 'Región Metropolitana de Santiago', text: 'Paine', id: 123 },
        { parent: 'Región Metropolitana de Santiago', text: 'Pedro Aguirre Cerda', id: 98 },
        { parent: 'Región Metropolitana de Santiago', text: 'Peñaflor', id: 133 },
        { parent: 'Región Metropolitana de Santiago', text: 'Peñalolén', id: 97 },
        { parent: 'Región Metropolitana de Santiago', text: 'Pirque', id: 120 },
        { parent: 'Región Metropolitana de Santiago', text: 'Providencia', id: 96 },
        { parent: 'Región Metropolitana de Santiago', text: 'Pudahuel', id: 95 },
        { parent: 'Región Metropolitana de Santiago', text: 'Puente Alto', id: 118 },
        { parent: 'Región Metropolitana de Santiago', text: 'Quilicura', id: 94 },
        { parent: 'Región Metropolitana de Santiago', text: 'Quinta Normal', id: 93 },
        { parent: 'Región Metropolitana de Santiago', text: 'Recoleta', id: 92 },
        { parent: 'Región Metropolitana de Santiago', text: 'Renca', id: 91 },
        { parent: 'Región Metropolitana de Santiago', text: 'San Bernardo', id: 121 },
        { parent: 'Región Metropolitana de Santiago', text: 'San Joaquín', id: 90 },
        { parent: 'Región Metropolitana de Santiago', text: 'San José de Maipo', id: 119 },
        { parent: 'Región Metropolitana de Santiago', text: 'San Miguel', id: 89 },
        { parent: 'Región Metropolitana de Santiago', text: 'San Pedro', id: 129 },
        { parent: 'Región Metropolitana de Santiago', text: 'San Ramón', id: 88 },
        { parent: 'Región Metropolitana de Santiago', text: 'Santiago', id: 86 },
        { parent: 'Región Metropolitana de Santiago', text: 'Talagante', id: 134 },
        { parent: 'Región Metropolitana de Santiago', text: 'Tiltil', id: 85 },
        { parent: 'Región Metropolitana de Santiago', text: 'Vitacura', id: 87 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Chimbarongo', id: 153 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Chépica', id: 152 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Codegua', id: 135 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Coltauco', id: 137 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Coínco', id: 136 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Doñihue', id: 138 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Graneros', id: 139 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'La Estrella', id: 162 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Las Cabras', id: 140 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Litueche', id: 163 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Lolol', id: 154 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Machalí', id: 141 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Malloa', id: 142 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Marchigüe', id: 164 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Mostazal', id: 143 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Nancagua', id: 155 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Navidad', id: 165 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Olivar', id: 144 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Palmilla', id: 156 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Paredones', id: 166 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Peralillo', id: 157 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Peumo', id: 145 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Pichidegua', id: 146 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Pichilemu', id: 167 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Placilla', id: 158 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Pumanque', id: 159 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Quinta de Tilcoco', id: 147 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Rancagua', id: 148 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Rengo', id: 149 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Requínoa', id: 150 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'San Fernando', id: 160 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'San Vicente de Tagua Tagua', id: 151 },
        { parent: 'Región del Libertador General Bernardo O\'Higgins', text: 'Santa Cruz', id: 161 },
        { parent: 'Región del Maule', text: 'Cauquenes', id: 195 },
        { parent: 'Región del Maule', text: 'Chanco', id: 196 },
        { parent: 'Región del Maule', text: 'Colbún', id: 192 },
        { parent: 'Región del Maule', text: 'Constitución', id: 184 },
        { parent: 'Región del Maule', text: 'Curepto', id: 183 },
        { parent: 'Región del Maule', text: 'Curicó', id: 168 },
        { parent: 'Región del Maule', text: 'Empedrado', id: 185 },
        { parent: 'Región del Maule', text: 'Hualañé', id: 169 },
        { parent: 'Región del Maule', text: 'Licantén', id: 170 },
        { parent: 'Región del Maule', text: 'Linares', id: 187 },
        { parent: 'Región del Maule', text: 'Longaví', id: 191 },
        { parent: 'Región del Maule', text: 'Maule', id: 181 },
        { parent: 'Región del Maule', text: 'Molina', id: 171 },
        { parent: 'Región del Maule', text: 'Parral', id: 189 },
        { parent: 'Región del Maule', text: 'Pelarco', id: 179 },
        { parent: 'Región del Maule', text: 'Pelluhue', id: 197 },
        { parent: 'Región del Maule', text: 'Pencahue', id: 180 },
        { parent: 'Región del Maule', text: 'Rauco', id: 172 },
        { parent: 'Región del Maule', text: 'Retiro', id: 193 },
        { parent: 'Región del Maule', text: 'Romeral', id: 173 },
        { parent: 'Región del Maule', text: 'Río Claro', id: 186 },
        { parent: 'Región del Maule', text: 'Sagrada Familia', id: 174 },
        { parent: 'Región del Maule', text: 'San Clemente', id: 178 },
        { parent: 'Región del Maule', text: 'San Javier', id: 188 },
        { parent: 'Región del Maule', text: 'San Rafael', id: 182 },
        { parent: 'Región del Maule', text: 'Talca', id: 177 },
        { parent: 'Región del Maule', text: 'Teno', id: 175 },
        { parent: 'Región del Maule', text: 'Vichuquén', id: 176 },
        { parent: 'Región del Maule', text: 'Villa Alegre', id: 190 },
        { parent: 'Región del Maule', text: 'Yerbas Buenas', id: 194 },
        { parent: 'Región de Ñuble', text: 'Bulnes', id: 198 },
        { parent: 'Región de Ñuble', text: 'Chillán Viejo', id: 200 },
        { parent: 'Región de Ñuble', text: 'Chillán', id: 199 },
        { parent: 'Región de Ñuble', text: 'Cobquecura', id: 207 },
        { parent: 'Región de Ñuble', text: 'Coelemu', id: 208 },
        { parent: 'Región de Ñuble', text: 'Coihueco', id: 215 },
        { parent: 'Región de Ñuble', text: 'El Carmen', id: 201 },
        { parent: 'Región de Ñuble', text: 'Ninhue', id: 209 },
        { parent: 'Región de Ñuble', text: 'Pemuco', id: 202 },
        { parent: 'Región de Ñuble', text: 'Pinto', id: 203 },
        { parent: 'Región de Ñuble', text: 'Portezuelo', id: 210 },
        { parent: 'Región de Ñuble', text: 'Quillón', id: 204 },
        { parent: 'Región de Ñuble', text: 'Quirihue', id: 211 },
        { parent: 'Región de Ñuble', text: 'Ránquil', id: 212 },
        { parent: 'Región de Ñuble', text: 'San Carlos', id: 214 },
        { parent: 'Región de Ñuble', text: 'San Fabián', id: 218 },
        { parent: 'Región de Ñuble', text: 'San Ignacio', id: 205 },
        { parent: 'Región de Ñuble', text: 'San Nicolás', id: 216 },
        { parent: 'Región de Ñuble', text: 'Treguaco', id: 213 },
        { parent: 'Región de Ñuble', text: 'Yungay', id: 206 },
        { parent: 'Región de Ñuble', text: 'Ñiquén', id: 217 },
        { parent: 'Región del Biobío', text: 'Alto Biobío', id: 219 },
        { parent: 'Región del Biobío', text: 'Antuco', id: 220 },
        { parent: 'Región del Biobío', text: 'Arauco', id: 245 },
        { parent: 'Región del Biobío', text: 'Cabrero', id: 221 },
        { parent: 'Región del Biobío', text: 'Cañete', id: 246 },
        { parent: 'Región del Biobío', text: 'Chiguayante', id: 235 },
        { parent: 'Región del Biobío', text: 'Concepción', id: 233 },
        { parent: 'Región del Biobío', text: 'Contulmo', id: 247 },
        { parent: 'Región del Biobío', text: 'Coronel', id: 234 },
        { parent: 'Región del Biobío', text: 'Curanilahue', id: 248 },
        { parent: 'Región del Biobío', text: 'Florida', id: 236 },
        { parent: 'Región del Biobío', text: 'Hualpén', id: 237 },
        { parent: 'Región del Biobío', text: 'Hualqui', id: 238 },
        { parent: 'Región del Biobío', text: 'Laja', id: 222 },
        { parent: 'Región del Biobío', text: 'Lebu', id: 249 },
        { parent: 'Región del Biobío', text: 'Los Álamos', id: 250 },
        { parent: 'Región del Biobío', text: 'Los Ángeles', id: 223 },
        { parent: 'Región del Biobío', text: 'Lota', id: 239 },
        { parent: 'Región del Biobío', text: 'Mulchén', id: 224 },
        { parent: 'Región del Biobío', text: 'Nacimiento', id: 225 },
        { parent: 'Región del Biobío', text: 'Negrete', id: 226 },
        { parent: 'Región del Biobío', text: 'Penco', id: 240 },
        { parent: 'Región del Biobío', text: 'Quilaco', id: 227 },
        { parent: 'Región del Biobío', text: 'Quilleco', id: 228 },
        { parent: 'Región del Biobío', text: 'San Pedro de La Paz', id: 241 },
        { parent: 'Región del Biobío', text: 'San Rosendo', id: 229 },
        { parent: 'Región del Biobío', text: 'Santa Bárbara', id: 230 },
        { parent: 'Región del Biobío', text: 'Santa Juana', id: 242 },
        { parent: 'Región del Biobío', text: 'Talcahuano', id: 243 },
        { parent: 'Región del Biobío', text: 'Tirúa', id: 251 },
        { parent: 'Región del Biobío', text: 'Tomé', id: 244 },
        { parent: 'Región del Biobío', text: 'Tucapel', id: 231 },
        { parent: 'Región del Biobío', text: 'Yumbel', id: 232 },
        { parent: 'Región de La Araucanía', text: 'Angol', id: 252 },
        { parent: 'Región de La Araucanía', text: 'Carahue', id: 264 },
        { parent: 'Región de La Araucanía', text: 'Cholchol', id: 265 },
        { parent: 'Región de La Araucanía', text: 'Collipulli', id: 253 },
        { parent: 'Región de La Araucanía', text: 'Cunco', id: 266 },
        { parent: 'Región de La Araucanía', text: 'Curacautín', id: 254 },
        { parent: 'Región de La Araucanía', text: 'Curarrehue', id: 267 },
        { parent: 'Región de La Araucanía', text: 'Ercilla', id: 255 },
        { parent: 'Región de La Araucanía', text: 'Freire', id: 268 },
        { parent: 'Región de La Araucanía', text: 'Galvarino', id: 269 },
        { parent: 'Región de La Araucanía', text: 'Gorbea', id: 270 },
        { parent: 'Región de La Araucanía', text: 'Lautaro', id: 271 },
        { parent: 'Región de La Araucanía', text: 'Loncoche', id: 272 },
        { parent: 'Región de La Araucanía', text: 'Lonquimay', id: 256 },
        { parent: 'Región de La Araucanía', text: 'Los Sauces', id: 257 },
        { parent: 'Región de La Araucanía', text: 'Lumaco', id: 258 },
        { parent: 'Región de La Araucanía', text: 'Melipeuco', id: 273 },
        { parent: 'Región de La Araucanía', text: 'Nueva Imperial', id: 274 },
        { parent: 'Región de La Araucanía', text: 'Padre Las Casas', id: 275 },
        { parent: 'Región de La Araucanía', text: 'Perquenco', id: 276 },
        { parent: 'Región de La Araucanía', text: 'Pitrufquén', id: 277 },
        { parent: 'Región de La Araucanía', text: 'Pucón', id: 278 },
        { parent: 'Región de La Araucanía', text: 'Purén', id: 259 },
        { parent: 'Región de La Araucanía', text: 'Renaico', id: 260 },
        { parent: 'Región de La Araucanía', text: 'Saavedra', id: 279 },
        { parent: 'Región de La Araucanía', text: 'Temuco', id: 263 },
        { parent: 'Región de La Araucanía', text: 'Teodoro Schmidt', id: 280 },
        { parent: 'Región de La Araucanía', text: 'Toltén', id: 281 },
        { parent: 'Región de La Araucanía', text: 'Traiguén', id: 261 },
        { parent: 'Región de La Araucanía', text: 'Victoria', id: 262 },
        { parent: 'Región de La Araucanía', text: 'Vilcún', id: 282 },
        { parent: 'Región de La Araucanía', text: 'Villarrica', id: 283 },
        { parent: 'Región de Los Ríos', text: 'Corral', id: 285 },
        { parent: 'Región de Los Ríos', text: 'Futrono', id: 293 },
        { parent: 'Región de Los Ríos', text: 'La Unión', id: 292 },
        { parent: 'Región de Los Ríos', text: 'Lago Ranco', id: 294 },
        { parent: 'Región de Los Ríos', text: 'Lanco', id: 286 },
        { parent: 'Región de Los Ríos', text: 'Los Lagos', id: 287 },
        { parent: 'Región de Los Ríos', text: 'Mariquina', id: 289 },
        { parent: 'Región de Los Ríos', text: 'Máfil', id: 288 },
        { parent: 'Región de Los Ríos', text: 'Paillaco', id: 290 },
        { parent: 'Región de Los Ríos', text: 'Panguipulli', id: 291 },
        { parent: 'Región de Los Ríos', text: 'Río Bueno', id: 295 },
        { parent: 'Región de Los Ríos', text: 'Valdivia', id: 284 },
        { parent: 'Región de Los Lagos', text: 'Ancud', id: 313 },
        { parent: 'Región de Los Lagos', text: 'Calbuco', id: 304 },
        { parent: 'Región de Los Lagos', text: 'Castro', id: 314 },
        { parent: 'Región de Los Lagos', text: 'Chaitén', id: 323 },
        { parent: 'Región de Los Lagos', text: 'Chonchi', id: 315 },
        { parent: 'Región de Los Lagos', text: 'Cochamó', id: 305 },
        { parent: 'Región de Los Lagos', text: 'Curaco de Vélez', id: 316 },
        { parent: 'Región de Los Lagos', text: 'Dalcahue', id: 317 },
        { parent: 'Región de Los Lagos', text: 'Fresia', id: 306 },
        { parent: 'Región de Los Lagos', text: 'Frutillar', id: 307 },
        { parent: 'Región de Los Lagos', text: 'Futaleufú', id: 324 },
        { parent: 'Región de Los Lagos', text: 'Hualaihué', id: 325 },
        { parent: 'Región de Los Lagos', text: 'Llanquihue', id: 308 },
        { parent: 'Región de Los Lagos', text: 'Los Muermos', id: 309 },
        { parent: 'Región de Los Lagos', text: 'Maullín', id: 310 },
        { parent: 'Región de Los Lagos', text: 'Osorno', id: 297 },
        { parent: 'Región de Los Lagos', text: 'Palena', id: 326 },
        { parent: 'Región de Los Lagos', text: 'Puerto Montt', id: 311 },
        { parent: 'Región de Los Lagos', text: 'Puerto Octay', id: 298 },
        { parent: 'Región de Los Lagos', text: 'Puerto Varas', id: 312 },
        { parent: 'Región de Los Lagos', text: 'Puqueldón', id: 318 },
        { parent: 'Región de Los Lagos', text: 'Purranque', id: 299 },
        { parent: 'Región de Los Lagos', text: 'Puyehue', id: 300 },
        { parent: 'Región de Los Lagos', text: 'Queilén', id: 319 },
        { parent: 'Región de Los Lagos', text: 'Quellón', id: 320 },
        { parent: 'Región de Los Lagos', text: 'Quemchi', id: 321 },
        { parent: 'Región de Los Lagos', text: 'Quinchao', id: 322 },
        { parent: 'Región de Los Lagos', text: 'Río Negro', id: 301 },
        { parent: 'Región de Los Lagos', text: 'San Juan de la Costa', id: 302 },
        { parent: 'Región de Los Lagos', text: 'San Pablo', id: 303 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Aysén', id: 329 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Chile Chico', id: 333 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Cisnes', id: 330 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Cochrane', id: 334 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Coyhaique', id: 328 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Guaitecas', id: 331 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Lago Verde', id: 327 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'O\'Higgins', id: 335 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Río Ibáñez', id: 332 },
        { parent: 'Región de Aysén del General Carlos Ibáñez del Campo', text: 'Tortel', id: 336 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Antártica', id: 347 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Cabo de Hornos', id: 346 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Laguna Blanca', id: 339 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Natales', id: 337 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Porvenir', id: 343 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Primavera', id: 344 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Punta Arenas', id: 340 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Río Verde', id: 341 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'San Gregorio', id: 342 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Timaukel', id: 345 },
        { parent: 'Región de Magallanes y de la Antártica Chilena', text: 'Torres del Paine', id: 338 },
    ];

const address3GroupArray = ADDRESS3_LIST.reduce(function (obj, item) {
    obj[item.parent] = obj[item.parent] || [];
    obj[item.parent].push({ id: item.id, child: item.text });
    return obj;
}, {});

export const ADDRESS3_GROUPED: Array<IDataGrouped> = Object.keys(address3GroupArray).map(function (key) {
    return { parent: key, items: address3GroupArray[key] };
});